package com.patronat.top.ui.molecules.inputs

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.*

@Composable
fun SearchInput(
    query: String,
    onQueryChange: (String) -> Unit,
    placeholder: String,
    modifier: Modifier = Modifier
) {
    BasicTextField(
        value = query,
        onValueChange = onQueryChange,
        singleLine = true,
        textStyle = BodyLarge.copy(color = MineShaft900),
        cursorBrush = SolidColor(Primary600),
        // ВАЖЛИВО: modifier (з weight) застосовуємо до BasicTextField.
        // Також додаємо height(48.dp), щоб зафіксувати висоту компонента.
        modifier = modifier.height(48.dp),
        decorationBox = { innerTextField ->
            Row(
                modifier = Modifier
                    .fillMaxSize() // Row розтягується на весь розмір BasicTextField
                    .background(
                        color = MineShaft50, // Світло-сірий фон (#F6F6F6)
                        shape = RoundedCornerShape(16.dp)
                    )
                    .padding(horizontal = 16.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Іконка пошуку
                Icon(
                    painter = AppIcons.Search,
                    contentDescription = null,
                    tint = MineShaft500,
                    modifier = Modifier.size(20.dp)
                )

                Spacer(modifier = Modifier.width(12.dp))

                // Контейнер для тексту (Input + Placeholder)
                Box(modifier = Modifier.weight(1f)) {
                    if (query.isEmpty()) {
                        Text(
                            text = placeholder,
                            style = BodyLarge.copy(color = MineShaft500),
                            maxLines = 1
                        )
                    }
                    innerTextField()
                }
            }
        }
    )
}